<template>
  <div class="padding1">
    <b-modal
      v-model="warningBool"
      has-modal-card
      :destroy-on-hide="false"
      aria-modal>
      <template >
          <modal-form>
            <b-notification  position="is-bottom-right" :closable="false">
            Are you still there?
            Logging user out in {{ timeDisplay }}.
          </b-notification>
          </modal-form>
      </template>
    </b-modal>
  </div>
</template>

<script>
    export default {
      name: 'AutoLogoutTimer',
      data: function() {
        return  {
          events: ['click', 'mousemove', 'mousedown', 'scroll', 'keypress', 'load'],
          warningTimer: null,
          logoutTimer: null,
          warningBool: false,
          timerDiff: this.$appConfig.timeLogout - this.$appConfig.timeWarning,
          counter: this.$appConfig.timeLogout - this.$appConfig.timeWarning,
          intervalCD: null
        }
      },
      mounted() {
        this.events.forEach(function (event) {
            window.addEventListener(event, this.resetTimer);
        }, this);

        this.setTimers();
      },
      methods: {
        setTimers(){
          if (this.$store.state.travellersAndTrips.profile.firstName) {
            this.warningTimer = setTimeout(this.warningMessage, this.$appConfig.timeWarning)
            this.logoutTimer = setTimeout(this.logout, this.$appConfig.timeLogout)
          }

        },
        logout() {
          if (this.$store.state.travellersAndTrips.profile.firstName) {
              //localStorage.removeItem('isAuthenticated');
              this.$store.dispatch('clearState/clearState')
              this.$router.push({ path: '/login' })
          }

        },
        warningMessage() {
          if (this.$store.state.travellersAndTrips.profile.firstName) {
            this.indefinite()
          }
        },
        resetTimer() {
          clearTimeout(this.warningTimer);
          clearTimeout(this.logoutTimer);
          this.closeIndefinite()

          this.setTimers()
        },
        indefinite() {
            this.warningBool = true
            this.intervalCD = setInterval(this.updateCD, 1000)
        },
        updateCD() {
          if(this.counter - 1000 >= 0) {
            this.counter -= 1000
          }
          else {
            this.counter = 0
          }

        },
        closeIndefinite() {
                this.warningBool = false
                this.counter = this.timerDiff
                clearInterval(this.intervalCD)
            }

      },
      computed: {
        timeDisplay() {
          var minutes = Math.floor(this.counter/60000)
          var leftOver = this.counter%60000
          var seconds = leftOver/1000
          return (minutes > 0? minutes+'m': '') + (seconds > 0? ' ' + seconds + 's': '')
        }
      }
  }
</script>

<style scoped>
  .padding1 {
    padding-top: 10px;
  }
  .logo {
    border-radius: 5px;
  }
  .center {
    display: block;
    margin-left: auto;
    margin-right: auto;
    width: 50%;
    padding-bottom: 5px;
  }
  .centered {
    text-align: center;
  }
</style>
